import { useQuery } from '@tanstack/react-query';
import { getPendingCharges } from '../../../api/rentals';

const usePendingCharges = (options?: {}) => {
  const cacheKey = ['pendingCharges'];
  return useQuery(cacheKey, getPendingCharges, options);
};

export default usePendingCharges;
